import {z} from 'zod/v4';

// Contract keys are frozen independently of their title-case UI labels.
export const InstructionGenerationType = z.enum([
  'brand-guidelines',
  'design-system',
  'asset-guidelines',
  'cms-guidelines',
]);
export type InstructionGenerationType = z.infer<
  typeof InstructionGenerationType
>;

const instructionGenerationTitles = {
  'brand-guidelines': 'Brand Guidelines',
  'design-system': 'Design System',
  'asset-guidelines': 'Asset Guidelines',
  'cms-guidelines': 'CMS Guidelines',
} as const satisfies Record<InstructionGenerationType, string>;

export function instructionGenerationTitle(
  type: InstructionGenerationType
): string {
  return instructionGenerationTitles[type];
}

/** Resolves canonical generated skill slugs, including numeric conflict suffixes. */
export function instructionGenerationTitleFromSlug(
  slug: string
): string | undefined {
  for (const type of InstructionGenerationType.options) {
    if (!slug.startsWith(type)) continue;
    if (slug === type) return instructionGenerationTitle(type);

    const suffix = slug.slice(type.length);
    if (/^-\d+$/u.test(suffix)) {
      return `${instructionGenerationTitle(type)} ${suffix.slice(1)}`;
    }
  }

  return undefined;
}
